// Organisation approvals. The list is TOP-LEVEL {result_list,total_count}; the rest wrap in {result}.

import { DEMO_USER_ID, defineRoutes, demoError } from '../core';
import type { SubmitApprovalPayload } from '../../types/approval.type';
import {
  approveApproval,
  cancelApproval,
  findApproval,
  listApprovals,
  rejectApproval,
  submitApproval,
} from '../data/approvals';
import { body, guarded } from './errors';

export const approvalRoutes = defineRoutes([
  ['get', '/approvals/org/:orgId', (ctx) => listApprovals(ctx.params.orgId, ctx.query)],
  [
    'post',
    '/approvals/org/:orgId/submit',
    (ctx) => guarded(() => ({ result: submitApproval(ctx.params.orgId, DEMO_USER_ID, body<SubmitApprovalPayload>(ctx.body)) })),
  ],
  [
    'get',
    '/approvals/:id',
    (ctx) => {
      const a = findApproval(ctx.params.id);
      return a ? { result: a } : demoError(404, 'Approval request not found');
    },
  ],
  [
    'post',
    '/approvals/:id/approve',
    (ctx) => guarded(() => ({ result: approveApproval(ctx.params.id, DEMO_USER_ID, body<{ notes?: string }>(ctx.body).notes) })),
  ],
  [
    'post',
    '/approvals/:id/reject',
    (ctx) =>
      guarded(() => ({
        result: rejectApproval(ctx.params.id, DEMO_USER_ID, body<{ rejection_reason?: string }>(ctx.body).rejection_reason ?? ''),
      })),
  ],
  ['post', '/approvals/:id/cancel', (ctx) => guarded(() => ({ result: cancelApproval(ctx.params.id, DEMO_USER_ID) }))],
]);
